import connector from "service/connector";

const postFile = async data => await connector.connectFetchController(
  "upload/file", "POST", data
);

export { postFile };
export default { postFile };